// @ts-nocheck
import { orderConfirmationBillingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";
import { checkoutShippingBillingSubtitle, checkoutSubtitleProps } from "@store/Themes/common/props/checkout";

Object.assign(orderConfirmationBillingInformationStyles, {
    billingInformationTitle: checkoutSubtitleProps,
    billingAddressTitle: checkoutShippingBillingSubtitle,
});
